<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0"
                          :header="__('Basic data')">
                    <div class="grid">
                        <FormInputText fieldName="businessarea_name"
                                       label="Business area name"
                                       validation="required"
                                       size="10"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.businessarea_name" />

                        <FormInputText fieldName="symbol"
                                       label="Symbol"
                                       size="2"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.symbol" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="props.formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading)
})

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
